
(function () {
  'use strict';
  if (window.DaLucaReviewIframeCleanupV403) return;
  window.DaLucaReviewIframeCleanupV403 = true;

  function clean() {
    document.querySelectorAll('.template-product .jdgm-rev-widg__header iframe').forEach(function (frame) {
      frame.setAttribute('scrolling', 'no');
      frame.style.setProperty('overflow', 'hidden', 'important');
      frame.style.setProperty('border', '0', 'important');
      frame.style.setProperty('width', 'min(100%, 440px)', 'important');
      frame.style.setProperty('max-width', '440px', 'important');
      frame.style.setProperty('height', '145px', 'important');
      frame.style.setProperty('min-height', '145px', 'important');
      frame.style.setProperty('max-height', '145px', 'important');
      frame.style.setProperty('margin', '10px auto 4px', 'important');
    });
  }

  function schedule() {
    clean();
    [100, 350, 900, 1800].forEach(function (delay) {
      window.setTimeout(clean, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });

  var observer = new MutationObserver(function () {
    window.clearTimeout(observer._dlTimer);
    observer._dlTimer = window.setTimeout(clean, 60);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
